import actionTypes from './actionTypes';

const INITIAL_STATE = {
  autoGenerateLoading: false,
  autoGenerateFailed: false,
  autoGenerateError: false,
  autoGenerateMessage: null,
  autoGenerateFailedMessagesList: [],

  reservationDaysLoading: false,
  reservationDaysFailed: false,
  reservationDaysError: false,
  reservationDaysMessage: null,
  reservationDays: {},
  reservationDaysList: [],

  reservationDayDetailsLoading: false,
  reservationDayDetailsFailed: false,
  reservationDayDetailsError: false,
  reservationDayDetailsMessage: null,
  reservationDayDetails: {},

  reservationHourDetailsLoading: false,
  reservationHourDetailsFailed: false,
  reservationHourDetailsError: false,
  reservationHourDetailsMessage: null,
  reservationHourDetails: {},

  changeReservationDayStatusLoading: false,
  changeReservationDayStatusFailed: false,
  changeReservationDayStatusError: false,
  changeReservationDayStatusMessage: null,

  reservationHoursLoading: false,
  reservationHoursFailed: false,
  reservationHoursError: false,
  reservationHoursMessage: null,
  reservationHours: {},
  reservationHoursList: [],

  insertNewReservationDayLoading: false,
  insertNewReservationDayFailed: false,
  insertNewReservationDayError: false,
  insertNewReservationDayMessage: null,

  updateReservationDayLoading: false,
  updateReservationDayFailed: false,
  updateReservationDayError: false,
  updateReservationDayMessage: null,

  updateReservationHourLoading: false,
  updateReservationHourFailed: false,
  updateReservationHourError: false,
  updateReservationHourMessage: null,

  updateReservationHourStatusAtSchemticsStatusAtSchemticsLoading: false,
  updateReservationHourStatusAtSchemticsFailed: false,
  updateReservationHourStatusAtSchemticsError: false,
  updateReservationHourStatusAtSchemticsMessage: null,
  reservationHoursUpdatedList: [],

  insertNewReservationHourLoading: false,
  insertNewReservationHourFailed: false,
  insertNewReservationHourError: false,
  insertNewReservationHourMessage: null,

  deleteReservationDayLoading: false,
  deleteReservationDayFailed: false,
  deleteReservationDayError: false,
  deleteReservationDayMessage: null,

  deleteReservationHourLoading: false,
  deleteReservationHourFailed: false,
  deleteReservationHourError: false,
  deleteReservationHourMessage: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RESERVATION_DAYS_LOADING:
      return {
        ...state,
        reservationDaysLoading: true,
        reservationDaysFailed: false,
        reservationDaysError: false,
        reservationDaysMessage: null,
        reservationDays: {},
        reservationDaysList: [],
      };

    case actionTypes.FETCH_RESERVATION_DAYS_SUCCESS:
      return {
        ...state,
        reservationDaysLoading: false,
        reservationDaysFailed: false,
        reservationDaysError: false,
        reservationDaysMessage: null,
        reservationDays: { ...action.payload },
        reservationDaysList: [...action.payload.cafeDates],
      };
    case actionTypes.FETCH_RESERVATION_DAYS_FAILED: {
      let { message } = action.payload;
      return {
        ...state,
        reservationDaysLoading: false,
        reservationDaysFailed: true,
        reservationDaysError: false,
        reservationDaysMessage: message,
        reservationDays: {},
        reservationDaysList: [],
      };
    }

    case actionTypes.FETCH_RESERVATION_DAYS_REJECT:
      return {
        ...state,
        reservationDaysLoading: false,
        reservationDaysFailed: false,
        reservationDaysError: true,
        reservationDaysMessage: null,
        reservationDays: {},
        reservationDaysList: [],
      };

    case actionTypes.AUTO_GENERATE_RESERVATION_TIMES_LOADING: {
      return {
        ...state,
        autoGenerateLoading: true,
        autoGenerateFailed: false,
        autoGenerateError: false,
        autoGenerateMessage: '',
        autoGenerateFailedMessagesList: [],
      };
    }
    case actionTypes.AUTO_GENERATE_RESERVATION_TIMES_SUCCESS: {
      return {
        ...state,
        autoGenerateLoading: false,
        autoGenerateFailed: false,
        autoGenerateError: false,
        autoGenerateMessage: '',
        autoGenerateFailedMessagesList: [],
      };
    }
    case actionTypes.AUTO_GENERATE_RESERVATION_TIMES_FAILED: {
      const { message, errors } = action.payload;
      return {
        ...state,
        autoGenerateLoading: false,
        autoGenerateFailed: true,
        autoGenerateError: false,
        autoGenerateMessage: message,
        autoGenerateFailedMessagesList: errors || [],
      };
    }
    case actionTypes.AUTO_GENERATE_RESERVATION_TIMES_REJECT: {
      return {
        ...state,
        autoGenerateLoading: false,
        autoGenerateFailed: false,
        autoGenerateError: true,
        autoGenerateMessage: '',
        autoGenerateFailedMessagesList: [],
      };
    }
    case actionTypes.CLEAR_AUTO_GENERATE_RESERVATION_TIMES: {
      return {
        ...state,
        autoGenerateLoading: false,
        autoGenerateFailed: false,
        autoGenerateError: false,
        autoGenerateMessage: '',
        autoGenerateFailedMessagesList: [],
      };
    }

    case actionTypes.FETCH_RESERVATION_DAY_DETAILS_LOADING:
      return {
        ...state,
        reservationDayDetailsLoading: true,
        reservationDayDetailsFailed: false,
        reservationDayDetailsError: false,
        reservationDayDetailsMessage: null,
        reservationDayDetails: {},

        updateReservationDayLoading: false,
        updateReservationDayFailed: false,
        updateReservationDayError: false,
        updateReservationDayMessage: null,

        insertNewReservationDayLoading: false,
        insertNewReservationDayFailed: false,
        insertNewReservationDayError: false,
        insertNewReservationDayMessage: null,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };

    case actionTypes.FETCH_RESERVATION_DAY_DETAILS_SUCCESS:
      return {
        ...state,
        reservationDayDetailsLoading: false,
        reservationDayDetailsFailed: false,
        reservationDayDetailsError: false,
        reservationDayDetailsMessage: null,
        reservationDayDetails: { ...action.payload },

        updateReservationDayLoading: false,
        updateReservationDayFailed: false,
        updateReservationDayError: false,
        updateReservationDayMessage: null,

        insertNewReservationDayLoading: false,
        insertNewReservationDayFailed: false,
        insertNewReservationDayError: false,
        insertNewReservationDayMessage: null,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    case actionTypes.FETCH_RESERVATION_DAY_DETAILS_FAILED: {
      let { message } = action.payload;
      return {
        ...state,
        reservationDayDetailsLoading: false,
        reservationDayDetailsFailed: true,
        reservationDayDetailsError: false,
        reservationDayDetailsMessage: message,
        reservationDayDetails: {},

        updateReservationDayLoading: false,
        updateReservationDayFailed: false,
        updateReservationDayError: false,
        updateReservationDayMessage: null,

        insertNewReservationDayLoading: false,
        insertNewReservationDayFailed: false,
        insertNewReservationDayError: false,
        insertNewReservationDayMessage: null,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }

    case actionTypes.FETCH_RESERVATIONS_DAYS_REJECT:
      return {
        ...state,
        reservationDayDetailsLoading: false,
        reservationDayDetailsFailed: false,
        reservationDayDetailsError: true,
        reservationDayDetailsMessage: null,
        reservationDayDetails: {},

        updateReservationDayLoading: false,
        updateReservationDayFailed: false,
        updateReservationDayError: false,
        updateReservationDayMessage: null,

        insertNewReservationDayLoading: false,
        insertNewReservationDayFailed: false,
        insertNewReservationDayError: false,
        insertNewReservationDayMessage: null,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };

    case actionTypes.FETCH_RESERVATION_HOUR_DETAILS_LOADING:
      return {
        ...state,
        reservationHourDetailsLoading: true,
        reservationHourDetailsFailed: false,
        reservationHourDetailsError: false,
        reservationHourDetailsMessage: null,
        reservationHourDetails: {},

        updateReservationHourLoading: false,
        updateReservationHourFailed: false,
        updateReservationHourError: false,
        updateReservationHourMessage: null,

        insertNewReservationHourLoading: false,
        insertNewReservationHourFailed: false,
        insertNewReservationHourError: false,
        insertNewReservationHourMessage: null,
      };

    case actionTypes.FETCH_RESERVATION_HOUR_DETAILS_SUCCESS:
      return {
        ...state,
        reservationHourDetailsLoading: false,
        reservationHourDetailsFailed: false,
        reservationHourDetailsError: false,
        reservationHourDetailsMessage: null,
        reservationHourDetails: { ...action.payload },

        updateReservationHourLoading: false,
        updateReservationHourFailed: false,
        updateReservationHourError: false,
        updateReservationHourMessage: null,

        insertNewReservationHourLoading: false,
        insertNewReservationHourFailed: false,
        insertNewReservationHourError: false,
        insertNewReservationHourMessage: null,
      };
    case actionTypes.FETCH_RESERVATION_HOUR_DETAILS_FAILED: {
      let { message } = action.payload;
      return {
        ...state,
        reservationHourDetailsLoading: false,
        reservationHourDetailsFailed: true,
        reservationHourDetailsError: false,
        reservationHourDetailsMessage: message,
        reservationHourDetails: {},

        updateReservationHourLoading: false,
        updateReservationHourFailed: false,
        updateReservationHourError: false,
        updateReservationHourMessage: null,

        insertNewReservationHourLoading: false,
        insertNewReservationHourFailed: false,
        insertNewReservationHourError: false,
        insertNewReservationHourMessage: null,
      };
    }

    case actionTypes.FETCH_RESERVATIONS_HOURS_REJECT:
      return {
        ...state,
        reservationHourDetailsLoading: false,
        reservationHourDetailsFailed: false,
        reservationHourDetailsError: true,
        reservationHourDetailsMessage: null,
        reservationHourDetails: {},

        updateReservationHourLoading: false,
        updateReservationHourFailed: false,
        updateReservationHourError: false,
        updateReservationHourMessage: null,

        insertNewReservationHourLoading: false,
        insertNewReservationHourFailed: false,
        insertNewReservationHourError: false,
        insertNewReservationHourMessage: null,
      };

    case actionTypes.CHANGE_RESERVATION_DAY_STATUS_LOADING:
      return {
        ...state,
        changeReservationDayStatusLoading: true,
        changeReservationDayStatusFailed: false,
        changeReservationDayStatusError: false,
        changeReservationDayStatusMessage: null,
      };

    case actionTypes.CHANGE_RESERVATION_DAY_STATUS_SUCCESS:
      return {
        ...state,
        changeReservationDayStatusLoading: false,
        changeReservationDayStatusFailed: false,
        changeReservationDayStatusError: false,
        changeReservationDayStatusMessage: null,
      };
    case actionTypes.CHANGE_RESERVATION_DAY_STATUS_FAILED: {
      let { message } = action.payload;
      return {
        ...state,
        changeReservationDayStatusLoading: false,
        changeReservationDayStatusFailed: true,
        changeReservationDayStatusError: false,
        changeReservationDayStatusMessage: message,
      };
    }

    case actionTypes.FETCH_RESERVATIONS_DAYS_REJECT:
      return {
        ...state,
        changeReservationDayStatusLoading: false,
        changeReservationDayStatusFailed: false,
        changeReservationDayStatusError: true,
        changeReservationDayStatusMessage: null,
      };

    case actionTypes.FETCH_RESERVATION_HOURS_LOADING:
      return {
        ...state,
        reservationHoursLoading: true,
        reservationHoursFailed: false,
        reservationHoursError: false,
        reservationHoursMessage: null,
        reservationHours: {},
        reservationHoursList: [],
      };

    case actionTypes.FETCH_RESERVATION_HOURS_SUCCESS:
      return {
        ...state,
        reservationHoursLoading: false,
        reservationHoursFailed: false,
        reservationHoursError: false,
        reservationHoursMessage: null,
        reservationHours: { ...action.payload },
        reservationHoursList: [...action.payload.cafeTimeSlices],
      };
    case actionTypes.FETCH_RESERVATION_HOURS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        reservationHoursLoading: false,
        reservationHoursFailed: true,
        reservationHoursError: false,
        reservationHoursMessage: message,
        reservationHours: {},
        reservationHoursList: [],
      };
    }
    case actionTypes.FETCH_RESERVATIONS_HOURS_REJECT:
      return {
        ...state,
        reservationHoursLoading: false,
        reservationHoursFailed: false,
        reservationHoursError: true,
        reservationHoursMessage: null,
        reservationHours: {},
        reservationHoursList: [],
      };

    case actionTypes.INSERT_NEW_RESERVATION_DAY_LOADING:
      return {
        ...state,
        insertNewReservationDayLoading: true,
        insertNewReservationDayFailed: false,
        insertNewReservationDayError: false,
        insertNewReservationDayMessage: null,
      };

    case actionTypes.INSERT_NEW_RESERVATION_DAY_SUCCESS:
      return {
        ...state,
        insertNewReservationDayLoading: false,
        insertNewReservationDayFailed: false,
        insertNewReservationDayError: false,
        insertNewReservationDayMessage: null,
      };
    case actionTypes.INSERT_NEW_RESERVATION_DAY_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        insertNewReservationDayLoading: false,
        insertNewReservationDayFailed: true,
        insertNewReservationDayError: false,
        insertNewReservationDayMessage: message,
      };
    }
    case actionTypes.INSERT_NEW_RESERVATION_DAY_ERROR:
      return {
        ...state,
        insertNewReservationDayLoading: false,
        insertNewReservationDayFailed: false,
        insertNewReservationDayError: true,
        insertNewReservationDayMessage: null,
      };

    case actionTypes.UPDATE_RESERVATION_DAY_LOADING:
      return {
        ...state,
        updateReservationDayLoading: true,
        updateReservationDayFailed: false,
        updateReservationDayError: false,
        updateReservationDayMessage: null,
      };

    case actionTypes.UPDATE_RESERVATION_DAY_SUCCESS:
      return {
        ...state,
        updateReservationDayLoading: false,
        updateReservationDayFailed: false,
        updateReservationDayError: false,
        updateReservationDayMessage: null,
      };
    case actionTypes.UPDATE_RESERVATION_DAY_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        updateReservationDayLoading: false,
        updateReservationDayFailed: true,
        updateReservationDayError: false,
        updateReservationDayMessage: message,
      };
    }
    case actionTypes.UPDATE_RESERVATION_DAY_REJECT:
      return {
        ...state,
        updateReservationDayLoading: false,
        updateReservationDayFailed: false,
        updateReservationDayError: true,
        updateReservationDayMessage: null,
      };
    case actionTypes.UPDATE_RESERVATION_HOUR_LOADING:
      return {
        ...state,
        updateReservationHourLoading: true,
        updateReservationHourFailed: false,
        updateReservationHourError: false,
        updateReservationHourMessage: null,
      };

    case actionTypes.UPDATE_RESERVATION_HOUR_SUCCESS:
      return {
        ...state,
        updateReservationHourLoading: false,
        updateReservationHourFailed: false,
        updateReservationHourError: false,
        updateReservationHourMessage: null,
        reservationHoursList: action.payload,
      };
    case actionTypes.UPDATE_RESERVATION_HOUR_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        updateReservationHourLoading: false,
        updateReservationHourFailed: true,
        updateReservationHourError: false,
        updateReservationHourMessage: message,
      };
    }
    case actionTypes.UPDATE_RESERVATION_HOUR_REJECT:
      return {
        ...state,
        updateReservationHourLoading: false,
        updateReservationHourFailed: false,
        updateReservationHourError: true,
        updateReservationHourMessage: null,
      };

    case actionTypes.UPDATE_RESERVATION_HOUR_STATUS_LOADING:
      return {
        ...state,
        updateReservationHourStatusAtSchemticsLoading: true,
        updateReservationHourStatusAtSchemticsFailed: false,
        updateReservationHourStatusAtSchemticsError: false,
        updateReservationHourStatusAtSchemticsMessage: null,
        reservationHoursUpdatedList: [],
        reservationHoursList: [],
      };

    case actionTypes.UPDATE_RESERVATION_HOUR_STATUS_SUCCESS:
      return {
        ...state,
        updateReservationHourStatusAtSchemticsLoading: false,
        updateReservationHourStatusAtSchemticsFailed: false,
        updateReservationHourStatusAtSchemticsError: false,
        updateReservationHourStatusAtSchemticsMessage: null,
        reservationHoursUpdatedList: action.payload,
        reservationHoursList: action.payload,
      };
    case actionTypes.UPDATE_RESERVATION_HOUR_STATUS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        updateReservationHourStatusAtSchemticsLoading: false,
        updateReservationHourStatusAtSchemticsFailed: true,
        updateReservationHourStatusAtSchemticsError: false,
        updateReservationHourStatusAtSchemticsMessage: message,
        reservationHoursUpdatedList: [],
        reservationHoursList: [],
      };
    }
    case actionTypes.UPDATE_RESERVATION_HOUR_STATUS_REJECT:
      return {
        ...state,
        updateReservationHourStatusAtSchemticsLoading: false,
        updateReservationHourStatusAtSchemticsFailed: false,
        updateReservationHourStatusAtSchemticsError: true,
        updateReservationHourStatusAtSchemticsMessage: null,
        reservationHoursUpdatedList: [],
        reservationHoursList: [],
      };

    case actionTypes.INSERT_NEW_RESERVATION_HOUR_LOADING:
      return {
        ...state,
        insertNewReservationHourLoading: true,
        insertNewReservationHourFailed: false,
        insertNewReservationHourError: false,
        insertNewReservationHourMessage: null,
      };

    case actionTypes.INSERT_NEW_RESERVATION_HOUR_SUCCESS:
      return {
        ...state,
        insertNewReservationHourLoading: false,
        insertNewReservationHourFailed: false,
        insertNewReservationHourError: false,
        insertNewReservationHourMessage: null,
      };
    case actionTypes.INSERT_NEW_RESERVATION_HOUR_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        insertNewReservationHourLoading: false,
        insertNewReservationHourFailed: true,
        insertNewReservationHourError: false,
        insertNewReservationHourMessage: message,
      };
    }
    case actionTypes.INSERT_NEW_RESERVATION_HOUR_ERROR:
      return {
        ...state,
        insertNewReservationHourLoading: false,
        insertNewReservationHourFailed: false,
        insertNewReservationHourError: true,
        insertNewReservationHourMessage: null,
      };

    case actionTypes.DELETE_RESERVATION_DAY_LOADING:
      return {
        ...state,
        deleteReservationDayLoading: true,
        deleteReservationDayFailed: false,
        deleteReservationDayError: false,
        deleteReservationDayMessage: null,
      };

    case actionTypes.DELETE_RESERVATION_DAY_SUCCESS:
      return {
        ...state,
        deleteReservationDayLoading: false,
        deleteReservationDayFailed: false,
        deleteReservationDayError: false,
        deleteReservationDayMessage: null,
      };
    case actionTypes.DELETE_RESERVATION_DAY_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        deleteReservationDayLoading: false,
        deleteReservationDayFailed: true,
        deleteReservationDayError: false,
        deleteReservationDayMessage: message,
      };
    }
    case actionTypes.DELETE_RESERVATION_DAY_ERROR: {
      return {
        ...state,
        deleteReservationDayLoading: false,
        deleteReservationDayFailed: false,
        deleteReservationDayError: true,
        deleteReservationDayMessage: null,
      };
    }

    case actionTypes.DELETE_RESERVATION_HOUR_LOADING:
      return {
        ...state,
        deleteReservationHourLoading: true,
        deleteReservationHourFailed: false,
        deleteReservationHourError: false,
        deleteReservationHourMessage: null,
      };

    case actionTypes.DELETE_RESERVATION_HOUR_SUCCESS:
      return {
        ...state,
        deleteReservationHourLoading: false,
        deleteReservationHourFailed: false,
        deleteReservationHourError: false,
        deleteReservationHourMessage: null,
      };
    case actionTypes.DELETE_RESERVATION_HOUR_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        deleteReservationHourLoading: false,
        deleteReservationHourFailed: true,
        deleteReservationHourError: false,
        deleteReservationHourMessage: message,
      };
    }
    case actionTypes.DELETE_RESERVATION_HOUR_ERROR: {
      return {
        ...state,
        deleteReservationHourLoading: false,
        deleteReservationHourFailed: false,
        deleteReservationHourError: true,
        deleteReservationHourMessage: null,
      };
    }

    default:
      return state;
  }
};
